var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"Calculators"}}),_c('ContentRow',[_c('ContentContainer',{staticClass:"content-container--medium"},[_c('SectionTitle',[_vm._v("Mortgage Calculator")]),_c('HomeLoanCalculator')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }